import { FC, Fragment, useEffect, useState } from 'react';
import { getMyClinics } from '../../store/idbHandler';
import { RunningDiagnosisStatusType, RunningDiagnosisStrip } from './RunningDiagnosisStrip';
import { checkClinics } from './utils';

export const ClinicCheck: FC<{
    onSuccess: (obj: { [k: string]: string }) => void;
    onFailure: (obj: { [k: string]: string }) => void;
}> = ({ children, onSuccess, onFailure }) => {
    const [status, setStatus] = useState<RunningDiagnosisStatusType>('running');

    useEffect(() => {
        const clinics = getMyClinics();
        checkClinics(clinics?.length)
            .then((res) => {
                onSuccess(res);
                setStatus('success');
            })
            .catch((err) => {
                onFailure(err);
                setStatus('failed');
            });
    }, []);
    return (
        <Fragment>
            <RunningDiagnosisStrip name="Clinics associated with your account" status={status} />
            {children}
        </Fragment>
    );
};
